import { FormProvider } from 'react-hook-form';
import { useCreateBranchForm } from './hooks';
import { CreateBranchFormPresentation } from './presentations';

export const CreateBranchForm: React.FC = () => {
  const {
    state: { methods, isSubmitDisabled },
    actions: { handleSubmit },
  } = useCreateBranchForm();

  return (
    <FormProvider {...methods}>
      <CreateBranchFormPresentation isSubmitDisabled={isSubmitDisabled} onSubmit={handleSubmit} />
    </FormProvider>
  );
};
